
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_mac",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.MAC')
        },
        value() {
            return this.unitHwId
        },
        icon() {
            return this.showIcon ? false : false //ToDo need create icon
        }
    },
}
</script>

<style scoped>

</style>